const JwtDecode = require("jwt-decode");

const getToken = () => {
    return (localStorage.getItem('icurious-auth-token'))
}

const getDevToken = () => {
    return (localStorage.getItem('icurious-dev-token'))
}

const setToken = (obj) => {
    localStorage.setItem('icurious-auth-token', obj.token);
    localStorage.setItem('firstName', obj.firstName);
    localStorage.setItem('lastName', obj.lastName);
    localStorage.setItem('email', obj.email);
}

const setDevToken = (obj) => {
    localStorage.setItem('icurious-dev-token', obj.token);
    localStorage.setItem('ic-dev-firstName', obj.firstName);
    localStorage.setItem('ic-dev-lastName', obj.lastName);
    localStorage.setItem('ic-dev-email', obj.email);
}

const deleteToken = () => {
    localStorage.removeItem('icurious-auth-token');
    localStorage.removeItem('firstName');
    localStorage.removeItem('lastName');
    localStorage.removeItem('email');
    localStorage.removeItem('icurious-dev-token');
    localStorage.removeItem('ic-dev-firstName');
    localStorage.removeItem('ic-dev-lastName');
    localStorage.removeItem('ic-dev-email');
}

const getValue = (id) => {
    let Token = getToken();
    if (Token) {
        let decodedToken = JwtDecode(getToken()) || {}
        return decodedToken[id] || null;
    } else {
        return null
    }
}

module.exports = {
    getToken,
    deleteToken,
    setToken,
    getValue,
    setDevToken,
    getDevToken
}